module.exports = __webpack_public_path__ + "static/media/charging-station.67e3565b.svg";